module.exports = __webpack_public_path__ + "static/media/close.b98dffbe.svg";